{
  "index.description": "Ойынды теледидар қолданатын Wi‑Fi желісіндегі телефонда немесе проекторда ашып, оны контроллер ретінде пайдаланыңыз.",
  "index.go_to_tv": "TV-ге өту",

  "tv.players": "Ойыншылар",
  "tv.waiting": "Күтуде…",
  "tv.scan_qr": "QR кодты сканерлеңіз",
  "tv.point_camera": "Телефон камерасын осы QR кодқа бағыттаңыз",
  "tv.enter_code": "Немесе төмендегі кодты қолданбаға қолмен енгізіңіз:",
  "tv.same_wifi": "Байланыс әлсіз болса, телефон мен теледидардың бір Wi-Fi желісінде екеніне көз жеткізіңіз",
  "tv.need_help": "Маған көмек керек",
  "tv.post_qr_hint": "Егер ойын мобильді құрылғыда ұзақ іске қосылмаса, «Ажырату» түймесін басыңыз немесе бетті жаңартыңыз, содан кейін қайта қосылыңыз.\n\nТұрақты жұмыс үшін теледидарда да, телефонда да бір Wi-Fi желісін пайдаланыңыз.",
  "tv.refresh_page": "Бетті жаңарту",
  "tv.choose_game": "Телефоннан ойынды таңдаңыз",
  "tv.refresh_qr": "Жаңарту",
  "tv.connecting": "Қосылуда…",
  "tv.available_games": "Браузерге арналған қолжетімді ойындар:",
  "tv.establishing": "Телефоныңызбен\nбайланыс орнатылуда",
  "tv.send_logs": "Логты жіберу",
  "tv.sending_logs": "Логтар жіберілуде…",
  "tv.net.direct": "Тамаша байланыс",
  "tv.net.different": "Телефон мен теледидар әртүрлі желіде сияқты. Оларды бір Wi-Fi желісіне қосыңыз",
  "tv.net.internet": "Интернет арқылы байланыс — кідірістер болуы мүмкін. Бір Wi-Fi желісіне қосылған дұрыс",
  "tv.net.relay": "Байланыс баяу. Телефон мен теледидарды бір Wi-Fi желісіне қосыңыз",
  "tv.net.same_network_blocked": "Сіз бір Wi-Fi желісіндесіз, бірақ тікелей қосылу қолжетімсіз — кідірістер болуы мүмкін. Телефонның қонақ желісінде емес екенін тексеріңіз",
  "tv.net.different_lan": "Телефон мен теледидар әртүрлі роутерлерге қосылған — тікелей қосылу қолжетімсіз, кідірістер болуы мүмкін. Оларды бір Wi-Fi желісіне қосыңыз",
  "tv.net.failed": "Қосылу мүмкін болмады. Екі құрылғының да бір Wi-Fi желісінде екенін тексеріп, қайталап көріңіз",
  "tv.net.unstable": "Байланыс тұрақсыз",
  "tv.net.got_it": "Түсінікті",
  "tv.connection_lost": "Байланыс үзілді",
  "tv.connection_lost_sub": "Телефон теледидармен байланысын жоғалтты.\nЕкі құрылғының да бір Wi-Fi желісінде екеніне көз жеткізіңіз",
  "tv.reconnect": "Қайта қосылу",
  "tv.game_unavailable": "Ойын қолжетімсіз",
  "tv.game_unavailable_sub": "Теледидар арқылы ойнау үшін осындай белгішесі бар ойынды таңда",
  "tv.p2p_rtt_title": "P2P: ICE кідірісі (RTT), WebRTC статистикасы бойынша",
  "tv.webrtc_stats_title": "FPS (сызу), DataChannel хабарламалары/с (шикі ағын), ICE RTT (мс)",

  "game.game_over": "ОЙЫН АЯҚТАЛДЫ",
  "game.score": "Ұпай:",
  "game.winner": "ЖЕҢІМПАЗ!",
  "game.tie": "ТЕҢ ОЙЫН!",
  "game.pause": "ҮЗІЛІС",
  "fruit.combo": "Комбо x {n}",
  "fruit.score": "ҰПАЙ",
  "game.classic": "Классика",
  "game.arcade": "Аркада",
  "game.zen": "Дзен",
  "game.level": "Деңгей",
  "game.points": "Ұпай",

  "calib.dark.title": "Қараңғы екен! Біз сені көрмей тұрмыз!",
  "calib.dark.sub": "Жарықты қос немесе терезеге жақын тұр",
  "calib.bright.title": "Тым жарық! Біз сені көрмей тұрмыз!",
  "calib.bright.sub": "Пердені жап немесе терезеден алыстау тұр",
  "calib.low_conf.title": "Сені еш көре алмай тұрмыз!",
  "calib.low_conf.sub": "Бірдеңе кедергі келтіріп тұрған болуы мүмкін немесе сен фонмен араласып кеттің",

  "tv.log_sent": "Лог жіберілді (жазбалар: {n})",
  "tv.log_send_error": "Логты жіберу сәтсіз аяқталды",
  "tv.entered_code": "Енгізілген код:",
  "tv.connected": "Қосылды!",
  "tv.choose_game_title": "Телефоннан ойынды таңда",
  "tv.choose_game_sub": "Телефондағы қолданбаны ашып, ойнағыңыз келетін ойынды таңдаңыз",
  "tv.choose_mode_title": "Ойын режимі мен\nойыншылар санын таңда",
  "tv.choose_mode_sub": "Қолжетімді режимдердің бірін және ойыншылар санын таңдаңыз",
  "tv.game": "Ойын",
  "tv.press_start": "Телефондағы СТАРТ түймесін басыңыз.",
  "tv.mode_summary": "Режим: {mode} · {players}.",
  "tv.players_one": "{n} ойыншы",
  "tv.players_many": "{n} ойыншы",
  "tv.pose_to_start": "Қалыпқа тұрыңыз — ойын автоматты түрде басталады.",
  "tv.p2p_connecting": "P2P қосылуда…",
  "tv.p2p_connecting_sub": "Телефонмен тікелей арна күтілуде (WebRTC DataChannel). Бір Wi‑Fi желісінде әдетте STUN жеткілікті; әйтпесе TURN баптаңыз.",
  "tv.p2p_failed": "P2P сәтсіз аяқталды",
  "tv.p2p_failed_sub": "Теледидардағы желі мен браузерді тексеріңіз. Жергілікті желіден тыс көбіне TURN қажет — docs/webrtc-native-connection.md қараңыз",
  "tv.p2p_timeout": "P2P орнатылмады",
  "tv.p2p_timeout_sub": "Күту уақыты бітті. WebRTC және UDP қажет; кейбір теледидарларда/желілерде TURN-сіз қосылу мүмкін емес.",
  "tv.p2p_reconnecting": "P2P: қайта қосылуда…",
  "tv.p2p_no_link": "P2P: байланыс жоқ",
  "tv.browser_outdated": "Браузеріңіз ескірген",
  "tv.browser_unsupported": "Өкінішке қарай, қазір пайдаланылып жатқан браузерге\nқолдау көрсетілмейді.\nҚолдау көрсетілетін браузерлердің бірін пайдаланыңыз",

  "game.flight_over": "Ұшу аяқталды! ⭐ {stars}",
  "game.chef_time_up": "Уақыт бітті! Ұпай: {score}",
  "game.chef_load_failed": "Ойын жүктелмеді",
  "game.sky_race_over": "Жарыс аяқталды! ⭐ {stars} · {meters}",
  "game.iq_over": "Раунд аяқталды! Ұпай: {score} · Дұрыс: {correct} / {total}",
  "game.building_world": "{map} — әлем құрылуда… {pct}%",
  "game.meters": "{n} м",
  "game.laser_dodge_warning": "Қызыл аймақтан кет!",
  "game.laser_dodge_round": "{n}-раунд",
  "game.laser_dodge_dodged": "Құтылдың! +{n}",
  "game.laser_dodge_hit": "Тиді!",
  "game.laser_dodge_not_seen": "Сені көре алмай тұрмыз",
  "game.laser_dodge_over": "Ойын аяқталды! Ұпай {score} · {round}-раунд",
  "game.choose_track": "Трассаны таңда",

  "map.ekibastuz": "Екібастұз",
  "map.astana": "Астана",
  "map.paris": "Париж",
  "map.barcelona": "Барселона",
  "map.almaty": "Алматы",

  "calib.hint.upper_body": "Иықтарыңыз бен қолдарыңыз көрінетіндей белгіленген аймақтың ішінде тұрыңыз",
  "calib.hint.waist_up": "Денеңіз белден басқа дейін көрінетіндей аймақтың ішінде тұрыңыз",
  "calib.hint.full_body": "Бүкіл денеңіз көрінетіндей белгіленген аймақтың ішінде тұрыңыз",
  "calib.hint.slice_to_start": "Ойынды бастау үшін жемісті кесіңіз",
  "calib.hint.touch_yellow_zone": "Бастау үшін сары аймақтың ішін түртіңіз",
  "calib.hint.touch_zone": "Бастау үшін аймақтың ішін түртіңіз",
  "calib.start": "Старт",

  "headless.menu_title": "Ойынды таңдаңыз",
  "headless.menu_sub": "Қолыңызды батырмаға апарып ұстап тұрыңыз — немесе пульттегі OK батырмасын басыңыз",
  "headless.mode_title": "Режим",
  "headless.mode_timed": "Уақытқа",
  "headless.mode_standard": "Таймерсіз",
  "headless.level_title": "Деңгей",
  "headless.play_again": "Тағы бір рет",
  "headless.to_menu": "Мәзірге",
  "headless.result_title": "Жарыс аяқталды!",
  "headless.result": "⭐ {stars} · {meters}",
  "headless.lost_body": "Жалғастыру үшін кадрға қайта тұрыңыз",
  "headless.level_default": "Аңғар"
}
